import execution from "config/resources/execution";
import { baseResourceBody } from "config/resources/record";

const executionType = `
    ${execution.graphql.resourceBody}
`;

const executionTypeListing = `
    ${execution.graphql.resourceBodyListing}
`;

const executionSubscription = `
subscription execution($id: String!) {
    execution(id: $id) {
        ${executionType}
    }
}
`;

const executionsListSubscription = `
subscription execution_list($limit: Int, $offset: Int, $filter: String, $order: String) {
    execution_list(limit: $limit, offset: $offset, filter: $filter, order: $order) {
        execution_count,
        execution_list {
            ${executionTypeListing}
            project_id_project {
                id
            }
        }
    }
}
`;

const widgetExecutionsListSubscription = `
subscription execution_list($limit: Int, $offset: Int, $filter: String, $order: String) {
    execution_list(limit: $limit, offset: $offset, filter: $filter, order: $order) {
        execution_count,
        execution_list {
            ${baseResourceBody}
            started_at
            status
            type
            project_id_project {
                id
            }
        }
    }
}
`;

const executionSavepointListSubscription = `
subscription execution($id: String!, $limit: Int, $offset: Int, $order: String) {
    execution(id: $id) {
        execution_dump_list_execution_id(limit: $limit, offset: $offset, order: $order) {
            execution_dump_count
            execution_dump_list {
                id
                created_at
                action
                last_command
                lineno
            }
        }
    }
}
`;

const executionsCreateOperationMutation = `
mutation ($execution_id: String!, $operation: SchemalessData) {
    create_operation(body: {execution_id: $execution_id, operation: $operation}) {
        id
    }
}   
`;

export {
    executionsCreateOperationMutation,
    executionSavepointListSubscription,
    executionsListSubscription,
    executionSubscription,
    widgetExecutionsListSubscription,
};
